import type { ChatMode } from '../components/chat/ActiveConversationContext';

/**
 * The chat mode after a nav click floats a maximized chat down beside the destination page.
 *
 * BOTH maximized sizes float to a panel: the side dock (`expanded`) and Symphony's `fullscreen`. Any
 * non-maximized mode (`bubble`, `panel`) is left untouched. `fullscreen` was originally omitted (it
 * postdates this transition), which left a fullscreen chat with an active conversation covering the
 * page it navigated to — the Settings screen opened behind the overlay (#12548822344).
 *
 * Pure so the contract is unit-testable; the live `floatChatIfMaximized` action delegates here.
 */
export function floatedMode(mode: ChatMode): ChatMode {
  return mode === 'expanded' || mode === 'fullscreen' ? 'panel' : mode;
}

/**
 * Whether the URL names a thread to open (`?conversation=<id>`). The home route's empty-landing collapse must
 * not fire on such a URL: the chat mounts empty for a render before it adopts the id, and collapsing then sent
 * a profile-link visitor to Home instead of into the thread.
 */
export function urlNamesConversation(query: Record<string, string | string[] | undefined>): boolean {
  const value = query.conversation;
  return typeof value === 'string' && value.trim().length > 0;
}
